import api from './client';
import type { ApiResponse } from '../../types/api';

export interface LogEntry {
  level: 'debug' | 'info' | 'warn' | 'error';
  message: string;
  metadata?: Record<string, any>;
  timestamp?: string;
  userId?: string;
  botId?: string;
  action?: string;
  creditsUsed?: number;
}

export const logEvent = async (entry: LogEntry): Promise<ApiResponse> => {
  try {
    return await api.post('/api/logs', {
      ...entry,
      timestamp: entry.timestamp || new Date().toISOString()
    });
  } catch (error) {
    console.error('Failed to log event:', error);
    return { success: false, message: 'Failed to log event' };
  }
};

export const getLogs = async (params: {
  startDate: string;
  endDate: string;
  level?: string;
  userId?: string;
  botId?: string;
  action?: string;
}): Promise<ApiResponse> => {
  return api.get('/api/logs', { params });
};

export const getUsageLogs = async (startDate: string, endDate: string): Promise<ApiResponse> => {
  return api.get('/api/logs/usage', {
    params: { startDate, endDate }
  });
};

export const getRevenueReport = async (startDate: string, endDate: string): Promise<ApiResponse> => {
  return api.get('/api/logs/revenue', {
    params: { startDate, endDate }
  });
};